import { z } from 'zod';

export const VOLUNTARY_CONTRIBUTION_PILOT_SLUGS = ['rotarysa'] as const;

export const CONTRIBUTION_PRESET_AMOUNTS_CENTS = [2500, 5000, 10000] as const;
export const CONTRIBUTION_MIN_AMOUNT_CENTS = 1000;

/** @deprecated Use CONTRIBUTION_PRESET_AMOUNTS_CENTS */
export const EREY_AMOUNTS_CENTS = CONTRIBUTION_PRESET_AMOUNTS_CENTS;

export type VoluntaryContributionCampaign = 'erey' | 'sustainability';
export type ContributionPresetAmountCents = (typeof CONTRIBUTION_PRESET_AMOUNTS_CENTS)[number];

export const VOLUNTARY_CONTRIBUTION_CAMPAIGN_LABELS = {
	erey: 'Every Rotarian, Every Year (EREY)',
	sustainability: 'RCSA Sustainability Fund'
} as const satisfies Record<VoluntaryContributionCampaign, string>;

export function formatVoluntaryContributionCampaignLabel(
	campaign: VoluntaryContributionCampaign
): string {
	return VOLUNTARY_CONTRIBUTION_CAMPAIGN_LABELS[campaign];
}

export type VoluntaryContributionsCheckoutSelection = {
	ereyAmountCents?: number;
	sustainabilityAmountCents?: number;
};

export const voluntaryContributionAmountCentsSchema = z
	.number()
	.int()
	.min(CONTRIBUTION_MIN_AMOUNT_CENTS);

export const voluntaryContributionsCheckoutSelectionSchema = z
	.object({
		ereyAmountCents: voluntaryContributionAmountCentsSchema.optional(),
		sustainabilityAmountCents: voluntaryContributionAmountCentsSchema.optional()
	})
	.strict();

export const voluntaryContributionsCheckoutBodySchema =
	voluntaryContributionsCheckoutSelectionSchema;

export function isVoluntaryContributionsPilotEnabled(orgSlug: string): boolean {
	return (VOLUNTARY_CONTRIBUTION_PILOT_SLUGS as readonly string[]).includes(orgSlug);
}

export function computeContributionSubtotalCents(
	selection?: VoluntaryContributionsCheckoutSelection
): number {
	if (!selection) return 0;
	let total = 0;
	if (selection.ereyAmountCents) {
		total += selection.ereyAmountCents;
	}
	if (selection.sustainabilityAmountCents) {
		total += selection.sustainabilityAmountCents;
	}
	return total;
}

export function buildVoluntaryContributionsOptionsBlock() {
	return {
		enabled: true as const,
		presetAmountsCents: [...CONTRIBUTION_PRESET_AMOUNTS_CENTS],
		minAmountCents: CONTRIBUTION_MIN_AMOUNT_CENTS
	};
}
